import db from "@/plugins/dexie";
import { USER_STORAGE  } from '@/constants/STORAGE'
import apirecebimentoweb from '@/services/api-recebimentoweb';
import moment from "moment-timezone";
import store from "@/store";
// import geraDataV2 from "../geraDataV2";
import geraData from "../geradata";

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}

export default async function $_enviaOrdemUnidade() {
  const token = JSON.parse(sessionStorage.getItem('auth:token'));
  let unidades = await db.ordemcarregamentounidade.toArray();
  unidades = unidades.filter(o => o.ocudatanuvem === null && !o.ocuexclusao);
  const idusuario = await getSessionStorage(USER_STORAGE.useidusuario);

  // Cria um array de Promises
  const promises = unidades.map(async (item) => {
    const payload = {
      ocudataalteracao: geraData(),
      ocudatacriacao: item?.ocudatacriacao,
      ocudatafinalizado: item?.ocudatafinalizado,
      ocuidaberturalote: item?.ocuidaberturalote,
      ocunumerobag: item?.ocunumerobag,
      ocuidlocalmovimentacaoestoque: item?.ocuidlocalmovimentacaoestoque,
      ocuidordemcarregamentoitem: item?.ocuidordemcarregamentoitem,
      ocuidusuario: idusuario,
      ocuorigem: item?.ocuorigem,
      ocuquantidade: item?.ocuquantidade,
    };

    if (item?.ocuidnuvem && item.ocuidnuvem !== 'null') payload.id = item.ocuidnuvem;

    let res = null;
    try {
      if (item.ocuidnuvem && item.ocuidnuvem !== 'null') {
        console.log('put - ', item);
        res = await apirecebimentoweb.put(`/ordemcarregamentounidade/${item.ocuidnuvem}`, payload, {
          headers: { Authorization: `Bearer ${token.token}` }
        });
      } else {
        console.log('post - ', item);
        res = await apirecebimentoweb.post('/ordemcarregamentounidade', payload, {
          headers: { Authorization: `Bearer ${token.token}` }
        });
      }
    } catch (err) {
      console.log(err);
    }

    if (res) {
      const alteracao = moment.utc(res.data.ocudataalteracao).format('YYYY-MM-DD HH:mm:ss.SSS');
      await db.ordemcarregamentounidade.update(item.id, {
        ocuidusuario: res.data.ocuidusuario,
        ocuidnuvem: res.data.id ?? item.ocuidnuvem,
        ocudataalteracao: alteracao,
        ocudatanuvem: alteracao,
      });
      store.dispatch('cache/atualizaData', { data: alteracao, tabela: 'ordemcarregamentounidade' });
    }
  });

  // Aguarda todas as requisições terminarem
  await Promise.all(promises);
}

export async function $_deletaOrdemUnidade() {
  const token = JSON.parse(sessionStorage.getItem('auth:token'));
  let unidades = await db.ordemcarregamentounidade.toArray();
  unidades = unidades.filter(o => o.ocuexclusao);
  // Aguarda os DELETEs: a O.C. sobe depois no sync.
  await Promise.all(unidades.map((item) => apirecebimentoweb.delete(`/ordemcarregamentounidade/app/${item.ocuidnuvem}`, {
      headers: {
          Authorization: `Bearer ${token.token}`
      }
  }).then(async (res) => {
      console.log(res, 'res');
      await db.ordemcarregamentounidade.where({id: item.id}).delete();
  }).catch((err) => {
      console.log(err);
  })));
}